import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { CommonService } from 'src/app/trip-replay/services/common.service';
import { MapControlService } from 'src/app/trip-replay/services/map-control.service';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { CommonCabService } from 'src/app/trip-view-cab/services/common-cab.service';
import { Employee, EmployeeDetails } from 'src/app/trip-replay/interfaces/employee-details.interface';
import { MileStonesBoundsService } from 'src/app/trip-replay/services/mile-stones-bounds.service';
import { DateUtils } from 'src/app/utils/days-utils';
@Component({
  selector: 'app-trip-replay-cab',
  templateUrl: './trip-replay-cab.component.html',
  styleUrls: ['./trip-replay-cab.component.scss'],
})
export class TripReplayCabComponent implements OnInit {
  response: any;
  tripId: String;
  tripDetails: any;
  loader: boolean = true;
  showSideBar: boolean = true;
  replayImgSrc: string;
  legUUID;
  cabRegNum="";
  selectedRadioValue = 'MOBILE';
  sequenceId = 0;
  isCompletedTrip = true;
  driverFixedDevice = false;
  caretImagePath: string = "";
  driverData: Object;
  adhoc_text: string;

  constructor(
    private commonService: CommonService,
    private commonCabService: CommonCabService,
    private activatedRoute: ActivatedRoute,
    private mapControlService: MapControlService,
    private envService: EnvironmentService,
    private mileStonesBoundsService : MileStonesBoundsService
  ) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.commonService.buid = params['buid'];
      this.commonService.source = params['source'] || '';
      this.commonCabService.buid = params['buid'];
      this.commonCabService.tripId = params['tripId'];
      this.commonService.tripId = params['tripId'];
      this.commonCabService.source = params['source'] || '';
    });
  }

  ngOnInit(): void {
    this.loader=true;
    this.replayImgSrc = this.envService.getReplayImgSrc();
    this.getTripData();
    this.getMetaData();
  }

  toggleSideBar() {
    this.showSideBar = !this.showSideBar;
  }

  getTripData(): void {
    this.loader=true;
    this.commonService.getTripDetails(this.commonService.tripId).subscribe(
      (res: any) => {
        if (res) {
          this.adhoc_text = res?.tripDetails?.adhocConversionAudit?.fieldchange || '';
          this.commonService.response = res;
          this.commonCabService.response = res;
          this.getSideViewDataCab(res);
          this.commonService.tripDetailsRes.next(res);
          this.tripDetails = res['tripDetails'];
          console.log(this.tripDetails);
          this.legUUID = this.tripDetails['tripUuid'];
          this.cabRegNum = this.tripDetails.vehicle.vehicleIdentification;
          this.getMilestones();
        }
      },
      (error) => {
        this.loader = true;
        console.log(error);
      }
    );
  }

  getMilestones() {
    this.loader = true;
    this.commonCabService
      .getTrackingSession(
        this.legUUID,
        (this.sequenceId = 0),
        this.cabRegNum,
        this.selectedRadioValue,
        this.isCompletedTrip,
        this.commonService.driverFixedDevice,
      )
      .subscribe(
        (res: any) => {
          let mileStones = res.milestones
          // this.unshiftStartMileStones(mileStones)
          // this.pushEndMileStones(mileStones)
          this.commonService.locationListRes.next(mileStones);
          this.getDeviceHealth();
        },
        (err) => console.log(err)
      );
  }
  
  unshiftStartMileStones(mileStones: any[]){

    console.log('--------------------------------------------------')
    console.log(
      'milestones before unshift',
      mileStones.length
    )
    const startTimeDifference = this.commonService.tripTimings.plannedStartTime - this.commonService.tripTimings.actualStartTime;
    const startTimeDifferenceInSeconds = startTimeDifference / 1000; // Convert to seconds
  
    console.log('Start time difference in seconds: ', startTimeDifferenceInSeconds);
  
    // Starting timestamp for start milestones
    let currentTimestamp = this.commonService.tripTimings.actualStartTime;

    this.commonService.outOfRangeLowerBound = Math.abs(Math.floor(startTimeDifferenceInSeconds));
  
    // Array to hold generated start milestones
    const startMilestones = [];
  
    for (let i = 0; i < Math.abs(Math.floor(startTimeDifferenceInSeconds)); i++) {
      currentTimestamp -= 1000; // Increment by 1 second
  
      // Create a milestone object without geocoordinates
      const milestone = {
        
        latitude: 12.917883,
        longitude: 77.638256,
        mBearing: 2.729908,
        mSpeed: 21.594118,
        mStep: 21.743597,
        mAccuracy: 9,
        timeStamp: new Date(currentTimestamp).toLocaleString(), // Optional formatted timestamp
        time: currentTimestamp,
        type: 1
      };
  
      startMilestones.push(milestone);
    }
    
    mileStones.unshift(...startMilestones);
    console.log(
      'milestones before unshift',
      mileStones.length
    )

  
    // Prepend generated start milestones to mileStones array
  }
  
  pushEndMileStones(mileStones: any[]){
    const endTimeDifference = this.commonService.tripTimings.actualEndTime - this.commonService.tripTimings.plannedEndTime;
    const endTimeDifferenceInSeconds = endTimeDifference / 1000; // Convert to seconds
  
    console.log('End time difference in seconds: ', endTimeDifferenceInSeconds);
  
    // Starting timestamp for end milestones
    let currentTimestamp = this.commonService.tripTimings.actualEndTime;
    this.commonService.outOfRangeUpperBound = Math.abs(Math.floor(endTimeDifferenceInSeconds));
  
    // Array to hold generated end milestones
    const endMilestones = [];
  
    for (let i = 0; i < Math.abs(Math.floor(endTimeDifferenceInSeconds)); i++) {
      currentTimestamp += 1000; // Increment by 1 second
  
      // Create a milestone object without geocoordinates
      const milestone = {
                
        latitude: 12.917883,
        longitude: 77.638256,
        mBearing: 2.729908,
        mSpeed: 21.594118,
        mStep: 21.743597,
        mAccuracy: 9,
        timeStamp: new Date(currentTimestamp).toLocaleString(), // Optional formatted timestamp
        time: currentTimestamp,
        type: 1
      };
  
      endMilestones.push(milestone);
    }
  
    // Append generated end milestones to mileStones array
    mileStones.push(...endMilestones);
  }

  getDeviceHealth() {
    // getting SOS location
    this.commonService
      .getDeviceHealth(
        this.tripDetails?.actualStartTime,
        this.tripDetails?.vehicle?.deviceDTO?.deviceId,
        this.tripDetails?.vehicle?.deviceDTO?.imei
      )
      .subscribe((res) => {
        this.commonService.healthLogRes.next(res);
        this.getDriverActions();
      });
  }
  ngOnDestroy(): void {
    this.commonService.driverFixedDevice=false;
      this.mapControlService.clearMap();
      this.mapControlService.restartCall$.next('');
  }
  getDriverActions() { 
    this.commonService.getDriverActions(this.tripDetails.tripUuid,this.commonService.tripId).subscribe((res)=>
      {
        this.driverData = res;
        this.commonService.callEmployeeDriverActions = this.driverData["callEmployeeDriverActions"]
        this.commonService.noShowDriverActions = this.driverData["noShowDriverActions"];  
        this.getDriverOffData();
        
      })
  }
  getDriverOffData(){
    this.commonService.getDriverOffData(this.tripDetails.vehicle.deviceDTO.imei,this.tripDetails.vehicle.vehicleIdentification,this.tripDetails.actualStartTime,this.tripDetails.actualEndTime,this.commonService.buid).subscribe((res:any)=>{
      if(Object.keys(res['eventMap'])?.length && res['eventMap']['DEVICE_INACTIVE']?.length) {
        this.commonService.driverOffData$.next(res);
      }
      // this.getMetaData()
      this.getDeviceEvents()
    })
  }

  getMetaData(){
    this.commonService.getMetaData().subscribe((res)=>
    {
    this.commonService.tripMetaData$.next(res);
    })
  }

  getDeviceEvents(){
    this.commonService.getDeviceEvents().subscribe((res:any)=>{
      console.log('Response is : ', res)
      this.commonService.deviceEventsData$.next(res)

      let mileStones = this.commonService.locationListRes.getValue();
      this.mileStonesBoundsService.getLowerBound();
      this.mileStonesBoundsService.getUpperBound();
      this.loader=false;
    })
  }


  cabResponse: any;
  timeZone = 'Asia/Kolkata';
  attendance: any =
    {
      adhocCount: 0,
      noShowCount: 0,
      totalPlannedEmployeesToBoard: 0,
      plannedemployeesBoarded: 0,
      totalCapacity: 0
    }

     getSideViewDataCab(res: any) {
      const allEmployees: EmployeeDetails[] = res['tripDetails'].employees.map((obj: Employee, index: number) => ({
        serialNumber: index + 1,
        name: obj?.name,
        Id: obj.employeeId,
        plannedPickUp: obj.plannedPickupLocation?.address,
        actualPickUp: obj.actualPickupLocation?.address,
        plannedDrop: obj.plannedDropLocation?.address,
        actualDrop: obj.actualDropLocation?.address,
        signIn: obj.actualPickupTime !== 0 ? DateUtils.formatTimeWithZone(obj.actualPickupTime, this.timeZone, 'HH:mm') : "--",
        signOut: obj.actualDropTime !== 0 ? DateUtils.formatTimeWithZone(obj.actualDropTime, this.timeZone, 'HH:mm') : "--",
        plannedSignOut: obj.plannedDropTime !== 0 ? DateUtils.formatTimeWithZone(obj.plannedDropTime, this.timeZone, 'HH:mm') : "--",
        plannedSignIn: obj.plannedPickupTime !== 0 ? DateUtils.formatTimeWithZone(obj.plannedPickupTime, this.timeZone, 'HH:mm') : "--",
        
        driverReportingTime: obj.driverReportingTime,
        reportingTimeDriver: obj.driverReportingTime !== 0 ? DateUtils.formatTimeWithZone(obj.driverReportingTime, this.timeZone, 'HH:mm')  : "--",

        isMArshal: obj.userType === 'ESCORT' ? true : false,
        reportTime: obj.driverReportingTime,
        distance: obj.distanceTravelled,
        gender: obj.gender,
        adhoc: obj.adhoc,
        noShow: obj.noShow,
        phone: obj.phoneNumber,
        empTripStatus: obj.empTripStatus,
        geocord: !!obj.actualPickupLocation?.geocord ? obj.actualPickupLocation.geocord : obj.plannedPickupLocation.geocord,
        plannedPickupTime: obj.plannedPickupTime !== 0 ? DateUtils.formatTimeWithZone(obj.plannedPickupTime, this.timeZone, 'HH:mm') : "--",
        actualPickupTime: obj.actualPickupTime,
        plannedPickUpLocation: obj.plannedPickupLocation,
        actualPickUpLocation: obj.actualPickupLocation,
        plannedDropTimestamp: obj.plannedDropTime,
        plannedPickupTimestamp: obj.plannedPickupTime,
        plannedEndTime: obj.plannedDropTime !== 0 ? DateUtils.formatTime(obj.plannedDropTime, 'HH:mm') : "--",
        actualEndTime: obj.actualEndTime !== 0 ? DateUtils.formatTime(obj.actualEndTime, 'HH:mm') : "--",   
        actualDropTime: obj.actualDropTime,
        plannedDropLocation: obj.plannedDropLocation,
        actualDropLocation: obj.actualDropLocation,
        escort: obj?.escort,
        signedOff: obj?.signedOff
      }));
      this.commonCabService.employeeDetails$.next(allEmployees);
    }
    
}
